import { SessionStatus } from '@/store/slices/session';
import type { StepKey } from '../store/customizer';

/** The saved setup fields the deploy step needs (the session's `customization_data`). */
type SavedSetup = {
  brandName?: string | null;
  country?: string | null;
  domain?: string | null;
  logo?: string | null;
} | null;

const filled = (value: string | null | undefined): boolean => typeof value === 'string' && value.trim() !== '';

/**
 * The step a bare `/account/onboarding` visit opens on. A build that is deploying, or whose deploy failed, opens on
 * the deploy step (live progress, or the review to relaunch), as `/` routes it. A session still in `customization`
 * whose region, name, domain and logo are all saved has finished setup and only lacks the launch, so it resumes on
 * the deploy step and its Finish setup button too; anything else starts at the region step. Pure.
 */
export const resumeStep = (status: SessionStatus | null, saved: SavedSetup | undefined): StepKey => {
  if (status === SessionStatus.deployment_in_progress || status === SessionStatus.deployment_failed) return 'deploy';
  return status === SessionStatus.customization &&
    filled(saved?.brandName) &&
    filled(saved?.country) &&
    filled(saved?.domain) &&
    filled(saved?.logo)
    ? 'deploy'
    : 'country';
};
